import React from "react";
import TelegramIcon from "@mui/icons-material/Telegram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { TELEGRAM_KANAL, WHATSAPP_KANAL } from "../consts/Kanallar";
import "./takipEt.css";

/**
 * İndirim detay sayfasında Telegram / WhatsApp kanalına davet: "Fırsatlar cebine gelsin" + iki yuvarlak marka ikonu
 * (2026-11-05; eskiden Telegram / Instagram / WhatsApp yazılı üç hap düğmeydi). Kullanıcı bir indirim linkinden geldiği
 * için takipçi kazanmanın en iyi yeri; indirim sona erdiyse (`vurgulu`) "kaçırma" mesajıyla öne çıkar.
 */
export default function TakipEt({ vurgulu }) {
    return (
        <div className={"te-kutu" + (vurgulu ? " te-vurgulu" : "")}>
            <span className="te-metin">{vurgulu ? "Bir dahakini kaçırma, fırsatlar cebine gelsin" : "Fırsatlar cebine gelsin"}</span>
            <a href={TELEGRAM_KANAL} target="_blank" rel="noopener noreferrer" className="te-ikon te-telegram" aria-label="Telegram kanalı" title="Telegram kanalı">
                <TelegramIcon fontSize="small" />
            </a>
            <a href={WHATSAPP_KANAL} target="_blank" rel="noopener noreferrer" className="te-ikon te-whatsapp" aria-label="WhatsApp kanalı" title="WhatsApp kanalı">
                <WhatsAppIcon fontSize="small" />
            </a>
        </div>
    );
}
